var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2427_3342",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.465332,
    y: 0.665894,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2427_3342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.96533 16.1659H6.02783L13.8403 8.35339L12.7778 7.29089L4.96533 15.1034V16.1659ZM3.46533 17.6659V14.4784L13.8403 4.10339C13.9931 3.95062 14.1586 3.8395 14.3369 3.77006C14.5152 3.70062 14.7027 3.66589 14.8994 3.66589C15.0961 3.66589 15.2848 3.70062 15.4653 3.77006C15.6459 3.8395 15.8126 3.95062 15.9653 4.10339L17.0278 5.16589C17.1806 5.31867 17.2917 5.48534 17.3612 5.66589C17.4306 5.84645 17.4653 6.03077 17.4653 6.21885C17.4653 6.41946 17.4305 6.61067 17.3607 6.79248C17.291 6.9743 17.18 7.14044 17.0278 7.29089L6.65283 17.6659H3.46533ZM13.2998 7.83146L12.7778 7.29089L13.8403 8.35339L13.2998 7.83146Z",
    fill: "#42526E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4b1c4e22f9f86de1a066e5267763da57.svg";
export { ForwardRef as ReactComponent };